import { withErrorBoundary } from "react-error-boundary";
import GenericErrorBoundary from "./ErrorWrapper";

/**
 * Wraps component with error boundary
 */
function ErrorBoundaryWrapper(Component) {
  return withErrorBoundary(Component, {
    FallbackComponent: GenericErrorBoundary,
  });
}

export default ErrorBoundaryWrapper;
